import { types } from './firebaseAnalytic.meta';
import * as EventKeys from './firebaseAnalytic.constant';

const recordEvent = (evt, data) => {
  return {
    event: evt,
    data: data,
  };
};

export const firebaseAnalyticsEvents = {
  [types.HOTEL_TAP_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.TAP_EVENT, payload),
  [types.HOTEL_VIEW_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.VIEW_EVENT, payload),
  [types.HOTEL_SEARCH_WIDGET_SUBMIT_SEARCH]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_SEARCH, payload),
  [types.HOTEL_SEARCH_INITIATED]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_SEARCH_INITIATED, payload),
  [types.HOTEL_SELECT_HOTEL_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_SELECT_HOTEL, payload),
  [types.HOTEL_SELECT_ROOM_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_SELECT_ROOM, payload),
  [types.HOTEL_VIEW_ROOM_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_VIEW_ROOM, payload),
  [types.HOTEL_FIELD_LEFT_EMPTY]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_LEFT_EMPTY_FIELD, payload),
  [types.HOTEL_GUEST_DETAIL_SUMMIT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_GUEST_DETAIL_SUMMIT, payload),
  [types.HOTEL_GUEST_DETAIL_LOADED]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_GUEST_DETAIL_LOADED, payload),
  [types.HOTEL_PAYMENT_INITIATED]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_PAYMENT_INITIATED, payload),
  [types.HOTEL_VIEW_ITEM_LIST]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_VIEW_ITEM_LIST, payload),
  [types.HOTEL_SELECT_ITEM]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_ITEM_SELECT, payload),
  [types.HOTEL_ADD_TO_CART]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_ADD_TO_CART, payload),
  [types.HOTEL_BEGIN_CHECKOUT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_BEGIN_CHECKOUT, payload),
  [types.HOTEL_ADD_PAYMENT_INFO]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_ADD_PAYMENT_INFO, payload),
  [types.HOTEL_PURCHASE_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_PURCHASE, payload),
  [types.HOTEL_SELECT_DEFAULT_HOTEL_EVENT]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_SELECT_DEFAULT_HOTEL, payload),
  [types.HOTEL_SELECT_PRICE_FILTER]: ({ payload }) =>
    recordEvent(EventKeys.TAP_EVENT, payload),
  [types.HOTEL_DETAILED_REVIEWS]: ({ payload }) =>
    recordEvent(EventKeys.VIEW_EVENT, payload),
  [types.HOTEL_REVIEWS_CLICK]: ({ payload }) =>
    recordEvent(EventKeys.TAP_EVENT, payload),
  [types.HOTEL_ROOM_SELECT_MAP]: ({ payload }) =>
    recordEvent(EventKeys.HOTEL_ROOM_SELECT_MAP, payload),
  [types.HOTEL_SELECT_ROOM_FILTER]: ({ payload }) =>
    recordEvent(EventKeys.TAP_EVENT, payload),
  [types.HOTEL_TRACK_STATUS_CODE]: ({ payload }) =>
    recordEvent(EventKeys.TRACK_EVENT_NO_ECOMMERCE, payload),
  [types.HOTEL_TRACK_RECEIVE_API_RESPONSE]: ({ payload }) =>
    recordEvent(EventKeys.TRACK_EVENT_NO_ECOMMERCE, payload),
};
